<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div class="d-flex flex-column gap-8">
  <div id="header-container">
    <h3 id="header-text">Propulsion Data for Pivot Table</h3>
    <button mat-flat-button color="primary" id="run-report-button" class="action-button"
            (click)="onRunReport()"
            [disabled]="!(isScenarioSelected() && selectedGeography
            && geographyOptions.selectedOptions.length > 0 && startYear && endYear)">
      Run Report
    </button>
  </div>
  <div class="d-flex flex-column gap-8 ps-2 pe-2">
    <div class="d-flex gap-16">


      <div class="d-flex flex-column filter-container">
        <h3>Filter By:</h3>
        <mat-form-field subscriptSizing="dynamic" class="filter-options">
          <mat-label>Region</mat-label>
          <fab-multiselect
            name="regionFilter"
            [(ngModel)]="regionOptions.selectedOptions"
            (ngModelChange)="onFilterChange(REGION)"
            [options]="regionOptions.options"
            [disabled]="!isScenarioSelected()">
          </fab-multiselect>
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic" class="filter-options">
          <mat-label class="asterisk--before">Geography</mat-label>
          <mat-select [(ngModel)]="selectedGeography" id="geographyFilter" (selectionChange)="onGeographyChange()"
                      [disabled]="!isScenarioSelected()">
            <mat-option [value]="1">Subregion</mat-option>
            <mat-option *ngIf="selectedScenarioType === 'fcorg'" [value]="2">Market Area</mat-option>
            <mat-option [value]="3">Planning Market</mat-option>
          </mat-select>
        </mat-form-field>
        <ng-container *ngIf="selectedGeography">
          <mat-form-field *ngIf="selectedGeography === SUBREGION_FLAG" subscriptSizing="dynamic" class="filter-options">
            <mat-label class="asterisk--before">Subregion</mat-label>
            <fab-multiselect
              name="subregionFilter"
              [(ngModel)]="geographyOptions.selectedOptions"
              (ngModelChange)="onFilterChange(SUBREGION)"
              [options]="geographyOptions.options">
            </fab-multiselect>
          </mat-form-field>
          <mat-form-field *ngIf="selectedGeography === MKTAREA_FLAG" subscriptSizing="dynamic" class="filter-options">
            <mat-label class="asterisk--before">Market Area</mat-label>
            <mat-select [(ngModel)]="geographyOptions.selectedOptions" id="mktAreaFilter"
                        (selectionChange)="onFilterChange(MKTAREA)">
              <mat-option *ngFor="let mktArea of geographyOptions.options"
                          [value]="[mktArea]">{{ mktArea }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="selectedGeography === PLNGMKT_FLAG" subscriptSizing="dynamic" class="filter-options">
            <mat-label class="asterisk--before">Planning Market</mat-label>
            <fab-multiselect
              name="plngMktFilter"
              [(ngModel)]="geographyOptions.selectedOptions"
              (ngModelChange)="onFilterChange(PLNGMKT)"
              [options]="geographyOptions.options">
            </fab-multiselect>
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic" class="filter-options">
            <mat-label>Market Division</mat-label>
            <fab-multiselect
              name="mktDivFilter"
              [(ngModel)]="mktDivOptions.selectedOptions"
              (ngModelChange)="onFilterChange(MKTDIV)"
              [options]="mktDivOptions.options">
            </fab-multiselect>
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic" class="filter-options">
            <mat-label>Global Brand</mat-label>
            <fab-multiselect
              name="brandFilter"
              [(ngModel)]="brandOptions.selectedOptions"
              (ngModelChange)="onFilterChange(BRAND)"
              [options]="brandOptions.options">
            </fab-multiselect>
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic" class="filter-options">
            <mat-label>Program Code</mat-label>
            <fab-multiselect
              name="prgmCodeFilter"
              [(ngModel)]="prgmCodeOptions.selectedOptions"
              (ngModelChange)="onFilterChange(PRGMCODE)"
              [options]="prgmCodeOptions.options">
            </fab-multiselect>
          </mat-form-field>
          <div class="d-flex gap-16 flex-row justify-content-center ">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label class="asterisk--before">Start Year</mat-label>
              <mat-select [(ngModel)]="startYear" id="startYear">
                <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic">
              <mat-label class="asterisk--before">End Year</mat-label>
              <mat-select [(ngModel)]="endYear" id="endYear">
                <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-checkbox [(ngModel)]="showPlanningMarket">Show Planning Market</mat-checkbox>
        </ng-container>
      </div>
      <div class="content-container">
        <div class="d-flex flex-column justify-content-center">
          <mat-button-toggle-group [(ngModel)]="selectedScenarioType"
                                   (ngModelChange)="onSourceChange()"
                                   hideSingleSelectionIndicator="true"
                                   class="flex max-width">
            <mat-button-toggle id="forecast-org-toggle" [value]="'fcorg'" class="equal-flex-item">
              By Forecast Org
            </mat-button-toggle>
            <mat-button-toggle id="global-scenario-toggle" [value]="'global'" class="equal-flex-item">
              By Global Scenario
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="content-height w-100" *ngIf="selectedScenarioType === 'global'">
          <app-global-scenario-select-component
            [user]="stateService.getUserGmid()"
            [memberScenarioType]="0"
            [displayedMemberColumns]="memberScenarioColumns"
            (confirmEvent)="onGlobalScenarioSelect($event)">
          </app-global-scenario-select-component>
        </div>
        <div id="scenario-container" *ngIf="selectedScenarioType === 'fcorg'">
          <table class="scenario-info-table">
            <tr>
              <td></td>
              <td class="working-scenario-content-border working-scenario-content-border-top column-header">
                <h2><b>Working Scenario</b></h2>
                <h3 *ngIf="!selectedWorkingScenario" style="font-style: italic">Select Scenario
                  Below</h3>
              </td>
            </tr>

            <!-- FORECAST ORG ROW -->
            <tr>
              <td class="scenario-labels">Forecast Organization</td>
              <td *ngIf="selectedWorkingScenario" class="working-scenario-content-border">
                <div class="column-content">
                  <span class="column-text">{{ selectedWorkingScenario.fcorg }}</span>
                </div>
              </td>
              <!-- if no selected scenarios -->
              <td *ngIf="!selectedWorkingScenario" class="working-scenario-content-border column-content"></td>
            </tr>

            <!-- VEHICLE SCENARIO ROW -->
            <tr class="light-gray-background">
              <td class="scenario-labels">Vehicle Scenario</td>
              <td *ngIf="selectedWorkingScenario"
                  class="working-scenario-content-border">
                <div class="column-content">
                  <span class="column-text pad-left-50">{{ selectedWorkingScenario.vehScenId }}
                    - {{ selectedWorkingScenario.vehScenName }}</span>
                  <button mat-icon-button [matMenuTriggerFor]="vehicleMenu" class="vertical-dots"
                          matTooltip="More options">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #vehicleMenu="matMenu">
                    <button mat-menu-item (click)="openVehSelectComponent()" class="menu-width">
                      <mat-icon>autorenew</mat-icon>
                      <span>Change Scenario</span>
                    </button>
                  </mat-menu>
                </div>
              </td>
              <!-- if no selected scenarios -->
              <td *ngIf="!selectedWorkingScenario" class="working-scenario-content-border column-content">
          <span class="hyperlink"
                tabindex="0"
                (click)="openVehSelectComponent()"
                (keydown.enter)="openVehSelectComponent()">Select Vehicle Scenario</span>
              </td>
            </tr>

            <!-- PROPULSION SCENARIO ROW -->
            <tr>
              <td class="scenario-labels">Propulsion Scenario</td>
              <td *ngIf="selectedWorkingScenario"
                  class="working-scenario-content-border working-scenario-content-border-bottom">
                <div class="column-content">
                  <span
                    class="column-text">{{ selectedWorkingScenario.propulsionScenario.id }}
                    - {{ selectedWorkingScenario.propulsionScenario.propulsionScenarioName }}</span>
                </div>
              </td>
              <!-- if no selected scenarios -->
              <td *ngIf="!selectedWorkingScenario"
                  class="working-scenario-content-border working-scenario-content-border-bottom column-content"></td>
            </tr>

          </table>
        </div>
      </div>
    </div>
  </div>
</div>

